export const COUPON_STATUS = {
  UNKNOWN: 'UNKNOWN',
  EXPIRED: 'EXPIRED',
  NOT_STARTED: 'NOT_STARTED',
  REDEEMED: 'REDEEMED',
  USED: 'USED',
  ACTIVE: 'ACTIVE',
  EXHAUSTED: 'EXHAUSTED'
};
export const DEFAULT_SHOWN_COUPON_NUM = 3;
export const MAXIMUM_PRICE_RANGE = 999;
export const IS_AUTHENTICATED = 'isAuthenticated';
export const PROMOTION_SUB_CATEGORY = {
  POSD: 'Buy$XGet$YOff',
  FST: 'Free-Shipping'
};
